import styled, { css } from 'styled-components'

const DetailInfoTableHeader = () => {
  return (
    <StyledWrapper>
      <tr>
        <th rowSpan={4}>구분</th>
        <th rowSpan={4}>
          본인 <br /> 맞은 문항수
        </th>
        <th rowSpan={4}>
          본인 <br /> 푼 문항수
        </th>
      </tr>
      <tr>
        <th colSpan={4}>전체 결과</th>
        <th colSpan={4}>지원 계열사/직무</th>
      </tr>
      <tr>
        <th colSpan={2}>응시자 평균</th>
        <th colSpan={2}>상위 30%</th>
        <th colSpan={2}>응시자 평균</th>
        <th colSpan={2}>상위 30%</th>
      </tr>
      <tr>
        <th colSpan={1}>
          맞은 <br /> 문항수
        </th>
        <th colSpan={1}>
          푼 <br />
          문항수
        </th>
        <th colSpan={1}>
          맞은 <br />
          문항수
        </th>
        <th colSpan={1}>
          푼 <br />
          문항수
        </th>
        <th colSpan={1}>
          맞은 <br /> 문항수
        </th>
        <th colSpan={1}>
          푼 <br />
          문항수
        </th>
        <th colSpan={1}>
          맞은 <br />
          문항수
        </th>
        <th colSpan={1}>
          푼 <br />
          문항수
        </th>
      </tr>
    </StyledWrapper>
  )
}

export default DetailInfoTableHeader

const StyledWrapper = styled.thead`
  ${({ theme }) => css`
    & > tr {
      background-color: ${theme.background.bg_3};

      &:nth-child(2),
      &:nth-child(3) {
        height: 32px;
      }

      &:nth-child(4) {
        height: 50px;
      }

      & > th {
        padding: 8px 0px;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.47;
        letter-spacing: -0.6px;
        text-align: center;
        color: ${theme.color.text_1};
        border-right: 1px solid #eeeeee;
        border-top: 1px solid #eeeeee;
        vertical-align: middle;

        &:not([rowspan='4']):last-child {
          border-right: 0;
        }
      }
    }
  `}
`
